import { _ as __decorate } from '../../tslib.es6-M1zqH4el.js';
import { css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';

let Collapse = class Collapse extends LitElement {
    render() {
        return html `
      <div class="diamond-collapse__content">
        <slot></slot>
      </div>
    `;
    }
};
Collapse.styles = [
    css `
      @keyframes diamond-collapse-overflow {
        0%,
        99% {
          overflow: hidden;
        }
        100% {
          overflow: visible;
        }
      }
      :host {
        content-visibility: hidden;
        display: grid;
        grid-template-rows: 0fr;
        overflow: hidden;
        transition:
          grid-template-rows var(--diamond-transition),
          content-visibility var(--diamond-transition),
          overflow var(--diamond-transition);
        transition-behavior: allow-discrete;
      }

      .diamond-collapse__content {
        overflow: hidden;
      }

      :host([open]:not([open='false'])) {
        animation: diamond-collapse-overflow var(--diamond-transition) forwards;
        content-visibility: visible;
        grid-template-rows: 1fr;
      }

      :host([open]:not([open='false'])) .diamond-collapse__content {
        animation: diamond-collapse-overflow var(--diamond-transition) forwards;
      }
    `,
];
__decorate([
    property({ reflect: true, type: Boolean })
], Collapse.prototype, "open", void 0);
Collapse = __decorate([
    customElement('diamond-collapse')
], Collapse);

export { Collapse };
